module.exports = __webpack_public_path__ + "static/media/save.31200903.svg";